import { defineMessages } from 'react-intl';

export default defineMessages({
  issue: {
    id: 'frontbucket.repository.pullRequest.merge.issue',
    description: 'A jira issue',
    defaultMessage: 'Issue',
  },
  status: {
    id: 'frontbucket.repository.pullRequest.merge.status',
    description:
      'A status which can be assigned to a Jira issue, such as "in progress"',
    defaultMessage: 'Status',
  },
  notSupported: {
    id: 'frontbucket.repository.pullRequest.merge.notSupported',
    description:
      'A message telling the user that some issue transitions are hidden because they are not supported in bitbucket',
    defaultMessage:
      'Some transitions for this issue are not shown here because they require additional user input.',
  },
});
